<template>
    <footer v-if="!hideFooter">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-3">
                    <div class="accordion accordion--footer" v-if="lodash.get(regionData, 'footerLinks.popularSearches1.length', 0)">
                        <div aria-controls="footer-popular-searches1"
                             class="footer-section-heading collapsed"
                             data-target="#footer-popular-searches1"
                             data-toggle="collapse">{{ translate.home.popularSearches }}
                        </div>
                        <div class="accordion-content collapse"
                             id="footer-popular-searches1">
                            <ul class="footer-list">
                                <li v-for="link in lodash.get(regionData, 'footerLinks.popularSearches1', [])">
                                    <a :href="link.path">{{ link.title }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-3">
                    <div class="accordion accordion--footer" v-if="lodash.get(regionData, 'footerLinks.popularSearches2.length', 0)">
                        <div aria-controls="footer-popular-searches2"
                             class="footer-section-heading collapsed"
                             data-target="#footer-popular-searches2"
                             data-toggle="collapse">{{ translate.home.morePopularSearches }}
                        </div>
                        <div class="accordion-content collapse"
                             id="footer-popular-searches2">
                            <ul class="footer-list">
                                <li v-for="link in lodash.get(regionData, 'footerLinks.popularSearches2', [])">
                                    <a :href="link.path">{{ link.title }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="accordion accordion--footer">
                        <div aria-controls="footer-legals"
                             class="footer-section-heading collapsed"
                             data-target="#footer-legals"
                             data-toggle="collapse">{{ translate.home.legals }}
                        </div>
                        <div class="accordion-content collapse"
                             id="footer-legals">
                            <ul class="footer-list mb-sm-5">
                                <li>
                                    <a :href="ourMissionUrl">
                                        {{ translate.home.ourMission }}
                                    </a>
                                </li>
                                <li>
                                    <a :href="termsUrl">
                                        {{ translate.home.termsAndConditions }}
                                    </a>
                                </li>
                                <li>
                                    <a href="/datenschutzerklarung/">
                                        {{ translate.home.privacyPolicy }}
                                    </a>
                                </li>
                                <li>
                                    <a href="/cookie-richtlinie/">
                                        {{ translate.home.cookiePolicy }}
                                    </a>
                                </li>
                                <li>
                                    <a href="/impressum/">
                                        {{ translate.home.imprint }}
                                    </a>
                                </li>
                                <a href="http://www.age-label.com/parents" target="_blank">
                                    <picture :data-iesrc="`${cdnUrl}images/jusprog-age-xml-18.png`">
                                        <source :srcset="`${cdnUrl}images/jusprog-age-xml-18.webp`" type="image/webp">
                                        <source :srcset="`${cdnUrl}images/jusprog-age-xml-18.png`" type="image/png">
                                        <img alt="" class="mt-2" width="156" height="31"/>
                                    </picture>
                                </a>
                            </ul>
                            <div class="footer-images mb-4 mb-sm-2">
                                <picture :data-iesrc="`${cdnUrl}images/footersssl_small_compressed.png`">
                                    <source :srcset="`${cdnUrl}images/footersssl_small_compressed.webp`" type="image/webp">
                                    <source :srcset="`${cdnUrl}images/footersssl_small_compressed.png`" type="image/png">
                                    <img alt="" width="342" height="91" class="footersssl"/>
                                </picture>

                                <a href="https://twitter.com/Erobella_de" target="_blank"
                                   class="footer-twitter-image ml-sm-3 mt-3 mt-sm-0">

                                    <picture :data-iesrc="`${cdnUrl}images/footer-twitter.png`">
                                        <source :srcset="`${cdnUrl}images/footer-twitter-new.webp`" type="image/webp">
                                        <source :srcset="`${cdnUrl}images/footer-twitter.png`" type="image/png">
                                        <img alt="" width="130" height="24"/>
                                    </picture>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 d-flex flex-column justify-content-center align-items-start my-4 d-sm-none">
                    <region-selector-component class="w-50"></region-selector-component>
                </div>

                <div class="col-12 col-sm-6 col-lg-3 mt-0 footer-details">
                    <picture :data-iesrc="`${cdnUrl}images/footer-image-17-05-2023.png`">
                        <source
                            :srcset="`${cdnUrl}images/footer-image-17-05-2023.webp`"
                            type="image/webp">
                        <source
                            :srcset="`${cdnUrl}images/footer-image-17-05-2023.png`"
                            type="image/png">
                        <img alt="" class="footer-image" width="260" height="229"/>
                    </picture>

                    <region-selector-component class="d-none d-sm-flex"></region-selector-component>

                </div>
            </div>
        </div>
    </footer>

</template>

<script>

import RegionSelectorComponent from "@/components/partials/RegionSelectorComponent.vue";

const data = () => {
    return {
        lodash: _,
        cdnUrl: process.env.MIX_CDN2_URL,
    }
};

export default {
    data,
    computed: {
        ...mapState(['currentUser', 'translate', 'locale', 'regionData']),
        hideFooter() {
            return _.get(this, '$route.meta.hideBannersAndFooterOnMobile', false) && !utils.isDesktop();
        },
        ourMissionUrl() {
            if (typeof window === "undefined" || !this.locale) {
                return '/unsere-mission/';
            }

            switch (this.locale) {
                case 'en' :
                    return "/mission-statement/"
                case 'ro' :
                    return "/declaratie-de-misiune/"
                default:
                    return "/unsere-mission/"
            }
        },
        termsUrl() {
            switch (process.env.MIX_REGION_PATH) {
                case 'au' :
                    return "/au/erobella-agb/"
                default:
                    return "/erobella-agb/"
            }
        },
    },
    components: {
        RegionSelectorComponent,
    }
};
</script>
